import { render, staticRenderFns } from "./Parcelas.vue?vue&type=template&id=52cd336e"
import script from "./Parcelas.vue?vue&type=script&lang=js"
export * from "./Parcelas.vue?vue&type=script&lang=js"
import style0 from "./Parcelas.vue?vue&type=style&index=0&id=52cd336e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports